import {
  Component, ViewEncapsulation, ChangeDetectionStrategy, Input, Output, EventEmitter, OnInit
} from '@angular/core';
import { UntypedFormGroup, FormControl } from '@angular/forms';

import { FormInputType } from '@forms/form-text-input/entities/input-type';
import { FormValidationService } from '@reservation/services/form-validation.service';
import {
  DEFAULT_EMAIL_CONTROL, DEFAULT_PHONE_CONTROL, MAXLENGTH_EMAIL_CONTROL, MAXLENGTH_PHONE_CONTROL
} from '@forms/contact-form/constants/contact-form.constants';

@Component({
  selector: 'app-contact-info',
  templateUrl: './contact-info.component.html',
  styleUrls: ['./contact-info.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ContactInfoComponent implements OnInit {

  @Input() isSubmitted: boolean = false;
  @Input() withoutPhoneInfo: string;
  @Input() emailControl: string;
  @Input() phoneControl: string;
  @Input() phone: string;
  @Input() email: string;

  @Output() saveContactInfo: EventEmitter<{ phone: string, email: string }> = new EventEmitter();

  public onlyNumberInput: FormInputType = FormInputType.ONLY_NUMBERS;
  public emailInputType: FormInputType = FormInputType.EMAIL;
  public contactForm: UntypedFormGroup;
  public maxEmail: number = MAXLENGTH_EMAIL_CONTROL;
  public maxPhone: number = MAXLENGTH_PHONE_CONTROL;

  constructor(
    private formValidationService: FormValidationService
  ) { }

  ngOnInit(): void {
    this.createContactForm(this.email, this.phone);
  }

  public save(): void {
    this.isSubmitted = true;
    const invalidForm = this.formValidationService.formInvalidControls(this.contactForm);
    if (!invalidForm) {
      const values = this.contactForm.value;
      const email = values[this.emailControl] || '';
      const phone = values[this.phoneControl] || '';
      this.saveContactInfo.emit({ email, phone });
    }
  }

  private createContactForm(email: string, phone: string): void {
    this.contactForm = new UntypedFormGroup({
      [this.phoneControl]: new FormControl(phone || '', { validators: DEFAULT_PHONE_CONTROL.validator }),
      [this.emailControl]: new FormControl(email || '', { validators: DEFAULT_EMAIL_CONTROL.validator }),
    });
  }

}
